module.exports = __webpack_public_path__ + "static/media/mq.2c5a49b0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mq.svg
// module id = 2160
// module chunks = 0